import { useEffect } from "react";
import { X } from "lucide-react";

export default function BottomSheet({ open, onClose, title, children, testId }) {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100]" data-testid={testId}>
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-[2px] animate-fade-in"
        onClick={onClose}
      />
      <div className="absolute inset-x-0 bottom-0 bg-white rounded-t-3xl shadow-[0_-8px_30px_rgba(0,0,0,0.15)] max-h-[90vh] overflow-y-auto animate-sheet-up">
        <div className="w-12 h-1.5 rounded-full bg-[#e9ecef] mx-auto mt-3" />
        <div className="px-6 pt-4 pb-8">
          <div className="flex items-start justify-between mb-4 gap-3">
            <h2 className="font-display text-2xl font-extrabold tracking-tight text-[#212529]">
              {title}
            </h2>
            <button
              onClick={onClose}
              className="w-9 h-9 rounded-full bg-[#f8f9fa] hover:bg-[#e9ecef] flex items-center justify-center active:scale-95 transition-transform"
              aria-label="Close"
              data-testid="bottom-sheet-close"
            >
              <X className="w-5 h-5" strokeWidth={2.5} />
            </button>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
